(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/login-iam/views/start.js') >= 0) return;  svs.modules.push('/modules/login-iam/views/start.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.login_iam=_svs.login_iam||{};
_svs.login_iam.templates=_svs.login_iam.templates||{};
svs.login_iam.templates.start = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"containerRegion\" class=\"container-region js-react-container\"></div>";
},"useData":true});
Handlebars.partials['svs-login_iam-start'] = svs.login_iam.templates.start;
})(svs, Handlebars);


 })(window);